import { Injectable, signal } from '@angular/core';
import { ToastMessage } from '../interfaces/toast.interface';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastId = 0;

  public toasts = signal<ToastMessage[]>([]);

  public show(message: string, type: 'success' | 'danger' | 'info' = 'success', duration = 4000): void {
    const toast: ToastMessage = { id: ++this.toastId, message, type, duration };

    this.toasts.set([...this.toasts(), toast]);

    // Auto-remove after duration
    if (duration > 0) {
      setTimeout(() => this.remove(toast.id), duration);
    }
  }

  public remove(id: number): void {
    this.toasts.set(this.toasts().filter(toast => toast.id !== id));
  }
}
